import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class ChecklistConfigsService {

  static getAll(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}checklists/configs${params}`).then((data) => {
        resolve({ checklists: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAll(underDeviceGroupingId=null) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}checklists/configs/list${underDeviceGroupingId != null ? `?underDeviceGroupingId=${underDeviceGroupingId}` : ''}`).then((data) => {
        resolve({ checklists: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(configId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}checklists/configs/${configId}`).then((data) => {
        resolve({ checklistConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static save(configId, config) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}checklists/configs/${configId}`, config).then((data) => {
        resolve({ checklistConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(config) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}checklists/configs`, config).then((data) => {
        resolve({ checklistConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static archive(configId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}checklists/configs/${configId}`).then((data) => {
        resolve({response: data});
      }).catch(err => {
        reject(err);
      });
    });
  }

  static addTaskGroup(taskGroup) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}checklists/task-groups`, taskGroup).then((data) => {
        resolve({ id: data.data, response: data});
      }).catch(err => {
        reject(err);
      });
    });
  }

  static saveTaskGroup(taskGroupId, taskGroup) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}checklists/task-groups/${taskGroupId}`, taskGroup).then((data) => {
        resolve({ response: data });
      }).catch(err => {
        reject(err);
      });
    });
  }

  static getTaskGroups() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}checklists/task-groups`).then((data) => {
        resolve({ taskGroups: data.data, response: data });
      }).catch(err => {
        reject(err);
      });
    });
  }

  static getTaskOptionTypes() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}checklists/tasks/options/types`).then((data) => {
        resolve({ taskOptionTypes: data.data, response: data });
      }).catch(err => {
        reject(err);
      });
    });
  }

  static getChecklistConfigsForGrouping(groupingId, startDate) {
    // `${ROOT}groupings/${groupingId}/checklistConfigs/latest-versions?starting=${startDate}`
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}checklists/configs/${groupingId}/latest-versions?starting=${startDate}`).then((data) => {
        resolve({ checklistConfigs: data.data, response: data});
      }).catch(err => {
        reject(err);
      })
    })
  }

  static uploadContent(file, contentToken) {
    return new Promise((resolve, reject) => {
      var uploadData = new FormData();
      uploadData.append('file', file);
      uploadData.append('contentToken', contentToken)
      axios.post(`${ROOT}checklists/configs/contentUpload`, uploadData).then((_) => {
        resolve();
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getContentURL(contentToken) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}checklists/configs/contentDownloadURL?contentToken=${contentToken}`).then((data) => {
        resolve({ contentURL: data.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

export default ChecklistConfigsService;
